/* eslint-disable @typescript-eslint/no-unused-vars */
// Material Dashboard 2 PRO React TS Base Styles
import typography from '@theme/base/typography';
import borders from '@theme/base/borders';
import colors from '@theme/base/colors';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;
const { dark, secondary } = colors;

// types
type Types = any;

const tab: Types = {
  styleOverrides: {
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      flex: '1 1 auto',
      textAlign: 'center',
      maxWidth: 'unset !important',
      minWidth: 'unset !important',
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textTransform: 'none',
      lineHeight: 'inherit',
      paddingX: pxToRem(15),
      color: `${dark.main} !important`,
      '&.Mui-selected': {
        borderBottom: `2px solid ${secondary.main}`, // Add border for the active tab
        backgroundColor: 'transparent !important',
        color: `${secondary.main} !important`,
        fontWeight: 'bold'
      },

      '& .material-icons, .material-icons-round': {
        marginBottom: '0 !important',
        marginRight: pxToRem(6)
      },

      '& svg': {
        marginBottom: '0 !important',
        marginRight: pxToRem(6)
      }
    },

    labelIcon: {
      paddingTop: pxToRem(4)
    }
  }
};

export default tab;
